import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { httpReauest } from "../../utils/httpRequest";
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectCube } from "swiper/modules";
import StoryRender from "./StoryRender";

const StoryPage = ({ desktop, show, setshow, setChat }) => {
  const [category, setCategory] = useState([]);
  const [swiper, setSwiper] = useState();
  const [width, setwidth] = useState(0);
  const [step, setstep] = useState(0);
  const [stop, setstop] = useState(true);
  const [array, setarray] = useState([]);
  const [searchParams, setSearchParams] = useSearchParams();

  const navigate = useNavigate();

  useEffect(() => {
    getData();
  }, []);

  async function getData() {
    await httpReauest("GET", `/story`, {}, {}).then(({ data }) => {
      setCategory(data?.data);
    });
  }

  useEffect(() => {
    if (swiper) {
      if (step >= category[swiper?.activeIndex]?.images?.length) {
        setstep(0);
        setwidth(0);
        swiper.slideNext();
      }
    }
  }, [step]);

  if (desktop) {
    return (
      <div dir="rtl" className={"relative w-full h-full"}>
        <Swiper
          modules={[EffectCube]}
          effect="cube"
          cubeEffect={{ shadow: false, slideShadows: false }}
          onSlideChange={() => {
            setstop(true);
            setstep(0);
            setwidth(0);
            setTimeout(() => {
              setwidth(0);
              setstop(false);
            }, 80);
          }}
          className="w-full h-full"
          onSwiper={(swiper) => {
            setSwiper(swiper);
            swiper.slideTo(show?.index);
            swiper.on("slideChange", () => {
              if (swiper.activeIndex === swiper.slides.length - 1) {
                setshow({ show: false, index: null });
              }
            });
          }}
        >
          {category?.map((e, i) => {
            return (
              <>
                <SwiperSlide
                  key={`slider-unique-key-desktop-${i}`}
                  className="relative w-full h-full"
                >
                  <StoryRender
                    e={e}
                    storys={e.images}
                    array={e.images.length}
                    swiper={swiper}
                    stop={stop}
                    setwidth={setwidth}
                    setstep={setstep}
                    step={step}
                    width={width}
                    setstop={setstop}
                    desktop
                    setChat={setChat}
                    setshow={setshow}
                    type={e.type}
                    index={i}
                  />
                </SwiperSlide>
                {i === category.length - 1 && <SwiperSlide></SwiperSlide>}
              </>
            );
          })}
        </Swiper>
      </div>
    );
  }

  return (
    <div
      style={{ width: window.innerWidth, height: window.innerHeight }}
      className={"fixed left-0 top-0"}
    >
      <Swiper
        modules={[EffectCube]}
        effect="cube"
        cubeEffect={{ shadow: false, slideShadows: false }}
        onSlideChange={(e) => {
          setstop(true);
          setstep(0);
          setwidth(0);
          setTimeout(() => {
            setwidth(0);
            setstop(false);
          }, 100);
        }}
        className="w-full h-full"
        onSwiper={(swiper) => {
          setSwiper(swiper);
          swiper.slideTo(searchParams.get("index"));
          swiper.on("slideChange", () => {
            if (swiper.activeIndex === swiper.slides.length - 1) {
              navigate("/");
            }
          });
        }}
      >
        {category?.map((e, i) => {
          return (
            <>
              <SwiperSlide
                style={{ zIndex: swiper.activeIndex === i ? "50" : "0" }}
                key={`slider-unique-key-mobile-${i}`}
                className="relative w-full h-full"
              >
                <StoryRender
                  e={e}
                  storys={e.images}
                  array={e.images.length}
                  swiper={swiper}
                  stop={stop}
                  setwidth={setwidth}
                  setstep={setstep}
                  step={step}
                  width={width}
                  setstop={setstop}
                  type={e.type}
                  index={i}
                />
              </SwiperSlide>
              {i === category.length - 1 && <SwiperSlide></SwiperSlide>}
            </>
          );
        })}
      </Swiper>
    </div>
  );
};

export default StoryPage;
